import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { LookupService } from 'src/app/Services/LookupService';
import { IFormPermToAssessRemind } from "../../../../Models/Forms/IFormPermToAssessRemind";
import { FormPermToAssessRemindService } from "../../../../Services/FormPermToAssessRemindService";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';


@Component({
  selector: 'PermToAssesToRemind',
  templateUrl: './PermToAssessRemind.component.html',
  styleUrls: ['./PermToAssessRemind.component.css']

})


export class FormPermToAssesRemindComponent extends SpinnerBase implements OnInit {

  _myGlobals: Globals;
  reportParamArray: IReportParameter[];
  //public showSpinner: boolean = false;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  _lookupService: LookupService;
  sendersTitles: any[];
  formPermToAssessRemindDB: any = [];
  firstParaPart1: string = 'This letter is to remind you that you were sent a Permission to Assess form for assessments for your child’s special education services on ';
  firstParaPart2: string = 'The school has not yet received your signed copy. As you know, your permission is required prior to any assessments being conducted, and we need to assess your child prior to offering appropriate special education services.';

  thirdPara: string = 'Please return this signed form as soon as possible. If we do not receive the signed form within a week from this letter, we may need to take other action to ensure that your child receives appropriate educational services.';
  fourthPara: string = 'Thank you for your attention to this matter. If you have already sent us the form, please call and we will confirm when we received it. If you have any questions, please feel free to contact me at';
  fifthPara: string = 'Sincerely,';
  enclosureHeading: string = 'Enclosure: Annual Notification of Parent Rights and Procedural Safeguards';


  constructor(
    private globals: Globals, reportService: ReportService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService,
    private _formPermToAssessRemindService: FormPermToAssessRemindService) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
  }

  ngOnInit(): void {
    this.LoadFormPermToAssessReminderDetails();
    this.LoadLookupValues();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
  }

  LoadFormPermToAssessReminderDetails(): void {
    this._formPermToAssessRemindService.getFormPermToAssessRemind(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormPermToAssessRemind) => {
        this.formPermToAssessRemindDB = res,
          this.formPermToAssessRemindDB.permissionToAssessDate = new Date(this.formPermToAssessRemindDB.permissionToAssessDate);      
      },
        err => console.error(err)
      );
  }
  
  LoadLookupValues(): void {
    this.sendersTitles = [
      { value: "[Select One]", label: "[Select One]" },
      { value: "School Clerk", label: "School Clerk" },
      { value: "Resource Specialist", label: "Resource Specialist" },
      { value: "Psychologist", label: "Psychologist" },
      { value: "Speech & Language Pathologist", label: "Speech & Language Pathologist" },
      { value: "Administrator", label: "Administrator" },
      { value: "School Staff", label: "School Staff" }
    ];
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the PermToAssessRemind
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._formPermToAssessRemindService.insertUpdateFormPermToAssessRemind(this.formPermToAssessRemindDB)
      .subscribe((res: IFormPermToAssessRemind) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false;
        this.validateForm();
        this.LoadFormPermToAssessReminderDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )

  }

  validateForm() {
    this._formPermToAssessRemindService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormPermToAssessReminderDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formPermToAssessRemindDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.formPermToAssessRemindDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: this.selectedIepInstance.statusName == 'Draft' ? 'DRAFT DRAFT DRAFT' : '' },
      { parameterName: 'BlankForm', parameterValue: 'false' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formPermToAssessRemindDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formPermToAssessRemindDB.rdlFileNameSpanish, this.reportParamArray);
  }

}


